import {NotificationConfig} from "../queries/notificationConfig";


export const useNotificationConfigUpdate = () => {

    const update = (data) => {
        NotificationConfig.update(data)
    }

    return {update};
}